<template>
    <div class="relative isolate select-none overflow-hidden text-transparent
        before:absolute before:inset-0 before:animate-shimmer before:bg-gradient-to-r
        before:from-transparent before:to-transparent">
        <slot></slot>
    </div>
</template>
